import { TabPane as RCTabPane } from 'rc-tabs'

const TabPanel = ({ children, key, tab }) => {
  return (
    <RCTabPane className='tab-pane' key={key} tab={tab}>
      Welcome
    </RCTabPane>
  )
}

export default RCTabPane
